import { useContext } from 'react'
import { SaveStateContext, type SaveStateContextValue } from './SaveStateContextDef'

/**
 * Optional hook that returns null if used outside provider.
 * Useful for components that may or may not be in the provider tree.
 */
export function useOptionalSaveStateContext(): SaveStateContextValue | null {
  return useContext(SaveStateContext)
}
